import React from 'react';
import styles from './Step4CloudText.module.scss';
import posed from 'react-pose';
import classNames from 'classnames';

const Box = posed.div({
    enter: {
        x: 0,
        delay: 950,
        transition: {ease: 'easeOut'},
    },
    exit: {
        x: '100vw',
        transition: {ease: 'easeIn'},
    },
});

export default function Step4CloudText({className}) {
    return (
        <Box className={classNames(className, styles.cloud)}>
            <div className={styles.paragraph}>
                “Yeah, breakfast at Tiffany's and bottles of bubbles”
            </div>
            <div className={styles.paragraph}>
                “Girls with tattoos who like getting in trouble”
            </div>
        </Box>
    );
}
